export default "__VITE_ASSET__CzhfSetz__"